SelectionTemplate from ../templates/selection

export Selection := (self) ->
  element: SelectionTemplate
    selectionClass: self.selectionClass
    selectionCopy: self.selectionCopy
    selectionCut: self.selectionCut
    selectionDelete: self.selectionDelete
    selectionReset: self.selectionReset
    selectionMoveUp: self.selectionMoveUp
    selectionMoveDown: self.selectionMoveDown
    selectionMoveLeft: self.navigateLeft
    selectionMoveRight: self.navigateRight

export default Selection
